// extracted by mini-css-extract-plugin
module.exports = {"display":"styles_display__oa740"};